"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseShiftCancellationListItemDto = instanceOfNurseShiftCancellationListItemDto;
exports.NurseShiftCancellationListItemDtoFromJSON = NurseShiftCancellationListItemDtoFromJSON;
exports.NurseShiftCancellationListItemDtoFromJSONTyped = NurseShiftCancellationListItemDtoFromJSONTyped;
exports.NurseShiftCancellationListItemDtoToJSON = NurseShiftCancellationListItemDtoToJSON;
exports.NurseShiftCancellationListItemDtoToJSONTyped = NurseShiftCancellationListItemDtoToJSONTyped;
const NurseShiftCancellationReason_1 = require("./NurseShiftCancellationReason");
const ProfileNameDto_1 = require("./ProfileNameDto");
/**
 * Check if a given object implements the NurseShiftCancellationListItemDto interface.
 */
function instanceOfNurseShiftCancellationListItemDto(value) {
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    if (!('nurseProfile' in value) || value['nurseProfile'] === undefined)
        return false;
    return true;
}
function NurseShiftCancellationListItemDtoFromJSON(json) {
    return NurseShiftCancellationListItemDtoFromJSONTyped(json, false);
}
function NurseShiftCancellationListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reason': (0, NurseShiftCancellationReason_1.NurseShiftCancellationReasonFromJSON)(json['reason']),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'createdAt': (json['createdAt'] == null ? null : new Date(json['createdAt'])),
        'shiftId': json['shiftId'],
        'nurseProfile': (0, ProfileNameDto_1.ProfileNameDtoFromJSON)(json['nurseProfile']),
    };
}
function NurseShiftCancellationListItemDtoToJSON(json) {
    return NurseShiftCancellationListItemDtoToJSONTyped(json, false);
}
function NurseShiftCancellationListItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'reason': (0, NurseShiftCancellationReason_1.NurseShiftCancellationReasonToJSON)(value['reason']),
        'comment': value['comment'],
        'createdAt': (value['createdAt'] == null ? null : value['createdAt'].toISOString()),
        'shiftId': value['shiftId'],
        'nurseProfile': (0, ProfileNameDto_1.ProfileNameDtoToJSON)(value['nurseProfile']),
    };
}
//# sourceMappingURL=NurseShiftCancellationListItemDto.js.map